import styled from "styled-components";

interface IContainer {
    deleteNav?: boolean;
}

export const Container = styled.div <IContainer>`
    min-height: 100vh;
    width: 100%;
    display: grid; 
    grid-template-areas: 'header'
                        ${props => props.deleteNav ? '' : "'nav'"}
                        
                        'content'
                        'footer'; 

     grid-template-rows: 63px ${props => props.deleteNav ? '' : '72px'} auto 90px;

    .nav__mobile--container {
        display: block;
        background-color: ${props => props.theme.colors.brand4.dark};
        position: sticky;
        top: 0;
        z-index: 1;
    }

    .search__open {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 3;
        height: 100px;
        @media(min-width:768px) {
            height: 57px;
        }
    }

    @media(min-width:480px) {
        grid-template-rows: 93px ${props => props.deleteNav ? '' : '72px'} auto 90px;
    }

    @media(min-width:768px) {
        grid-template-areas: 'header'
                        'content'
                        'footer';
        grid-template-rows: 57px auto 90px;

        .nav__mobile--container {
            display: none;
        }
    }

` 